"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiateCheckoutCommand = void 0;
class InitiateCheckoutCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, currency, contents, content_type } = this.input;
        const { fbq: facebookQueue } = config;
        const object = {
            value: value,
            currency: currency,
            contents: contents,
            content_type: content_type,
        };
        facebookQueue('track', 'InitiateCheckout', object);
        facebookQueue('trackCustom', 'InitiateCheckoutWeb', object);
        return Promise.resolve();
    }
}
exports.InitiateCheckoutCommand = InitiateCheckoutCommand;
